import { z } from "zod/v4";
import { endpoint } from "@uri/typed-api";
import { aiQuery } from "./src/aiQuerySchema.ts";
import { eventEntrySchema } from "./src/fields.ts";

export const publicEventEntrySchema = eventEntrySchema.omit({
  apiSubmit: true,
  userSubmit: true,
});

const tasteDecisionSchema = z.object({
  event: z.string(),
  decision: z.string(),
  timestamp: z.number(),
});

export const webApi = {
  getEvents: endpoint({
    input: aiQuery,
    output: z.array(publicEventEntrySchema),
    authRequired: true,
  }),
  getUserTasteDecisions: endpoint({
    input: z.object({
      userId: z.string().optional(),
    }),
    output: z.array(tasteDecisionSchema),
    authRequired: true,
  }),
  getUserSavedEvents: endpoint({
    input: z.object({
      userId: z.string().optional(),
    }),
    output: z.array(publicEventEntrySchema),
    authRequired: true,
  }),
  getEventById: endpoint({
    input: z.object({
      eventId: z.string(),
    }),
    output: publicEventEntrySchema.nullable(),
    authRequired: true,
  }),
  checkUserPairing: endpoint({
    input: z.object({
      email: z.string(),
    }),
    output: z.object({
      isPaired: z.boolean(),
    }),
    authRequired: true,
  }),
  getApiToken: endpoint({
    input: z.object({}),
    output: z.object({
      token: z.string(),
    }),
    authRequired: true,
  }),
  recordTasteDecision: endpoint({
    input: z.object({
      eventId: z.string(),
      direction: z.enum(["like", "dislike"]),
    }),
    output: z.object({
      ok: z.boolean(),
    }),
    authRequired: true,
  }),
  getUserProfile: endpoint({
    input: z.object({}),
    output: z.object({
      userId: z.string(),
      location: z.string().optional(),
      city: z.string().optional(),
      country: z.string().optional(),
      coordinates: z.array(z.number()).nullable().optional(),
    }),
    authRequired: true,
  }),
} as const;
